<template>
  <div class="exact-sales">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Exact Sales CRM <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  title="Configurações"
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  title="Configurações"
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="exact-sales"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com Exact  Sales CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between align-items-center">
            <h4 class="modal-title">Configurar Exact Sales CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="error" />
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Versão Exact API</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="versionExactApi"
                  v-model="versionExactApi">
                  <option
                    v-for="option in versionExactApiOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <p class="text-center">
              Para gerar/copiar sua Token Exact API
              <a
                v-if="versionExactApi === 'v2'"
                class="link"
                href="https://app.exactspotter.com/spotter/configuracoes/integracoes"
                target="_blank">
                clique aqui
              </a>
              <a
                v-else
                class="link"
                href="https://app.exactsales.com.br/Configuracao/ConfiguracaoIntegracoes/Index"
                target="_blank">
                clique aqui
              </a>
            </p>
            <div class="form-group row">
              <label
                for="tokenExactApi"
                class="col-sm-4 col-form-label">Token Exact API</label>
              <div class="col-sm-8">
                <input
                  id="tokenExactApi"
                  type="text"
                  class="form-control"
                  v-model="tokenExactApi">
              </div>
            </div>
            <div
              v-if="versionExactApi === 'v1'"
              class="form-group row">
              <label
                for="emailExactApi"
                class="col-sm-4 col-form-label">Email Exact API</label>
              <div class="col-sm-8">
                <input
                  id="emailExactApi"
                  type="text"
                  class="form-control"
                  tabindex="3"
                  v-model="emailExactApi">
              </div>
            </div>
            <div
              v-if="hasAI"
              class="form-group row">
              <label class="col-sm-4 col-form-label">Usuário Exact Sales</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="userId"
                  v-model="userId">
                  <option
                    v-for="option in usersOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-if="hasAI && activeIntegration"
              class="alert alert-warning"
              role="alert">
              <strong>Atenção:</strong> Para utilizar a funcionalidade de comentários com IA, é necessário refazer a integração e selecionar um usuário. Por favor, caso ainda não tenha feito isso, desative e reative a integração para configurar o usuário.
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração com a Exact Sales CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Exact Sales CRM removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialExactSales"
      title="Tutorial Exact Sales CRM"
      video-url="https://www.youtube.com/embed/_KnxdMV4npo" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationExactSales',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      tokenExactApi: null,
      versionExactApi: 'v2',
      emailExactApi: this.$store.state.auth.user.email,
      userId: null,
      usersOptions: [],
      versionExactApiOptions: [
        { value: 'v2', text: 'V2 (app.exactspotter.com)' },
        { value: 'v1', text: 'V1 (app.exactsales.com.br)' }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=exactsales`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            if (this.integration.metadata.tokenExactApi) this.tokenExactApi = this.integration.metadata.tokenExactApi
            if (this.integration.metadata.versionExactApi) this.versionExactApi = this.integration.metadata.versionExactApi
            if (this.integration.metadata.emailExactApi) this.emailExactApi = this.integration.metadata.emailExactApi
            if (this.integration.metadata.userId) this.userId = this.integration.metadata.userId
          }
        })
        .catch(err => { this.$emit('onError', err) })
    },
    saveIntegration () {
      if (this.tokenExactApi && this.configReady) {
        this.error = null
        const integrationParams = {
          gateway: 'exactsales',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'exactsales'
            }
          },
          metadata: {
            tokenExactApi: this.tokenExactApi,
            versionExactApi: this.versionExactApi,
            emailExactApi: this.emailExactApi,
            webhookUrl: process.env.API4COM_WEBHOOK_RECEIVER_URL,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        if (this.integration && this.integration.metadata) integrationParams.metadata = Object.assign(this.integration.metadata, integrationParams.metadata)

        if (this.userId) integrationParams.metadata.userId = this.userId
        else delete integrationParams.metadata.userId

        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
          })
          .catch(err => {
            this.error = err
            // TEL-2243: o `friendly` do interceptor ja resolve `details.messages` pelo
            // FIELD_MESSAGES, mantem em pt-BR o que o backend ja manda traduzido e nomeia
            // o campo quando nao ha texto proprio. Montar `lines` aqui devolvia o texto do
            // LoopBack em ingles e ainda sobrescrevia a traducao.
          })
      } else {
        this.error = {
          message: 'Token Exact API é obrigatório'
        }
      }
    },
    toogleIntegration (event) {
      if (event.value === true) {
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      this.error = null
      this.configReady = false
      if (this.tokenExactApi) {
        if (this.hasAI) {
          this.loadUsers().then(_ => {
            this.configReady = true
          })
        } else {
          this.configReady = true
        }
      } else {
        this.configReady = true
      }
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.tokenExactApi = null
          this.versionExactApi = 'v2'
          this.emailExactApi = this.$store.state.auth.user.email
          this.userId = null
          this.usersOptions = []
          this.error = null
          this.configReady = false
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    tokenValidator () {
      if (this.tokenExactApi) {
        return loopback
          .get(`/integrations/exactsales/users?tokenExactApi=${this.tokenExactApi}&versionExactApi=${this.versionExactApi}`)
          .then(users => {
            if (users && Array.isArray(users)) {
              this.configReady = true
              this.error = null
              if (this.hasAI) {
                this.loadUsers()
              }
            } else {
              this.configReady = false
              this.error = {
                message: 'Token Exact API inválido'
              }
            }
          })
          .catch(err => {
            this.configReady = false
            if (err.statusCode === 429) this.error = err
            else {
              this.error = {
                message: 'Token Exact API inválido'
              }
            }
          })
      }
    },
    loadUsers () {
      return new Promise(resolve => {
        if (!this.tokenExactApi) {
          return resolve()
        }
        return loopback
          .get(`/integrations/exactsales/users?tokenExactApi=${this.tokenExactApi}&versionExactApi=${this.versionExactApi}`)
          .then(users => {
            if (users && users.length > 0) {
              this.usersOptions = [{ value: null, text: 'Associação automática pelo Exact Sales' }]
              users.forEach(user => {
                this.usersOptions.push({
                  value: user.id,
                  text: `${user.name || user.username || user.email}${user.email ? ` (${user.email})` : ''}`
                })
              })
              return resolve()
            } else {
              this.usersOptions = [{ value: null, text: 'Associação automática pelo Exact Sales' }]
              return resolve()
            }
          })
          .catch(err => {
            this.$emit('onError', err)
            return resolve()
          })
      })
    },
    openTutorial () {
      this.$refs.tutorialExactSales.open()
    }
  },
  computed: {
    hasAI () {
      return this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.user && this.$store.state.auth.user.hasAI === true
    },
    activeIntegration () {
      return this.integration && this.integration.gateway === 'exactsales'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    tokenExactApi: function (tokenExactApi) {
      if (tokenExactApi) this.tokenValidator()
    },
    versionExactApi: function () {
      this.tokenValidator()
    },
    emailExactApi: function (value) {
      if (value) {
        this.emailExactApi = value.replace(/[^A-Za-z0-9|_.@+-]/, '').toLowerCase()
        // eslint-disable-next-line
        const regexToValidateEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        if (this.emailExactApi && !regexToValidateEmail.test(this.emailExactApi)) {
          this.error = {
            message: 'Email inválido'
          }
        } else {
          this.error = null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/ExactSales.vue